import React, { useEffect, useMemo, useState } from 'react';
import VTOWidget from './components/VTOWidget';

const DemoPage = ({ onBack }) => {
  // Parse URL params for embed mode
  const { isEmbed, embedConfig } = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const embed = params.get('embed') === 'true';
    return {
      isEmbed: embed,
      embedConfig: null,
    };
  }, []);

  const [resolvedConfig, setResolvedConfig] = useState(embedConfig);
  const [embedError, setEmbedError] = useState(null);

  // Receive config via postMessage from the parent widget script.
  // The widget already called /api/vto/init from the merchant page (correct origin)
  // and forwards the result here rather than re-fetching (which would fail origin check).
  useEffect(() => {
    if (!isEmbed) return;

    const handleMessage = (e) => {
      if (!e.data || e.data.type !== 'VL_CONFIG') return;
      const cfg = e.data.config;
      if (!cfg) return;
      setResolvedConfig(cfg);
    };

    window.addEventListener('message', handleMessage);

    // Tell the parent widget we are ready to receive config.
    if (window.parent !== window) {
      window.parent.postMessage({ type: 'VL_READY' }, '*');
    }

    return () => window.removeEventListener('message', handleMessage);
  }, [isEmbed]);

  // Embedded mode: use the same VTOWidget code path as demo.
  if (isEmbed) {
    if (embedError) {
      return (
        <div className="h-screen w-screen bg-gray-900 text-white flex items-center justify-center p-4 text-center">
          {embedError}
        </div>
      );
    }

    if (!resolvedConfig) {
      return (
        <div className="h-screen w-screen bg-gray-900 text-white flex items-center justify-center">
          Loading try-on...
        </div>
      );
    }

    return (
      <div className="h-screen w-screen bg-gray-900 overflow-hidden">
        <VTOWidget initialConfig={resolvedConfig} embedded={true} minimalLoader={true} />
      </div>
    );
  }

  // Normal demo page: human verification then full-screen VTO only (no header/loader chrome)
  return (
    <div className="h-screen w-screen bg-gray-900 overflow-hidden">
      <VTOWidget embedded={true} minimalLoader={true} />
    </div>
  );
};

export default DemoPage;

